import logo from "./logo.svg";
import "./App.scss";
// import  "dis/bootstrap/less/bootstrap.less";
import ls from "local-storage";
import React from "react";
import { OpenRoutes, PrivateRoutes } from "./routes/router";
import auth from "./services/auth";
import Spinner from "./elements/Spinner";
import AppContext from "./contexts/AppContext";
import { Helmet } from "react-helmet";
import { __ } from "services/Translator";
import InactivityChecker from "elements/InactivityChecker";
import withClearCache from "./ClearCache";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function MainApp(props) {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);

  const authResult = new URLSearchParams(window.location.search);
  const afftoken = authResult.get("afftoken");

  const appContext = React.useMemo(
    () => ({
      updateUserObj: async (data) => {
        // console.log("UserUpdated", data);
        await checkLoggedIn();
      },
    }),
    []
  );

  const checkLoggedIn = async () => {
    var authenticated = await auth.isAuthenticated();
    if (authenticated) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  };

  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  const init = async () => {
    window.addEventListener("load", setVh);
    window.addEventListener("resize", setVh);
    await checkLoggedIn();
    setIsReady(true);
  };
  React.useEffect(() => {
    init();
  }, []);

  React.useEffect(() => {
    if (afftoken) {
      ls.set("afftoken", afftoken);
    }
  }, [afftoken]);

  if (isReady) {
    return (
      <>
        <Helmet>
          <title>{__("Blizz Casino | Sign Up today for a 100% of up to 1BTC!")}</title>
          <meta
            name="description"
            content={__(
              "Blizz Casino! Sign Up today and receive bonuses on your first 2 Deposits totalling 2.5 BTC - Double your Coins on us!"
            )}
          />
        </Helmet>
        <AppContext.Provider value={appContext}>
          {!isLoggedIn && <OpenRoutes {...props} />}
          {isLoggedIn && (
            <React.Fragment>
              <InactivityChecker />
              <PrivateRoutes {...props} />
            </React.Fragment>
          )}
        </AppContext.Provider>
      </>
    );
  } else {
    return <Spinner />;
  }
}

export default App;
